import { z } from 'zod';
import {} from './domain.js';
/**
 * The Google Play screenshot slot a Candidate is validated against.
 *
 * `DeviceSlot` names the device; this union is what a Technical Check needs,
 * because Android Automotive OS carries a category that changes whether
 * screenshots are required at all. The slot is always explicit: it is stored
 * with the Candidate and never inferred from image dimensions.
 */
export const AutomotiveCategorySchema = z.enum(['parked', 'nonParked']);
export const ScreenshotSlotSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('phone') }),
    z.object({ kind: z.literal('sevenInchTablet') }),
    z.object({ kind: z.literal('tenInchTablet') }),
    z.object({ kind: z.literal('chromebook') }),
    z.object({ kind: z.literal('androidTv') }),
    z.object({ kind: z.literal('wearOs') }),
    z.object({ kind: z.literal('automotive'), category: AutomotiveCategorySchema }),
    z.object({ kind: z.literal('xr') }),
]);
/** Phone is the ordinary default, chosen once when a screenshot Candidate is created. */
export const DEFAULT_SCREENSHOT_SLOT = { kind: 'phone' };
/**
 * Bridges the flat `DeviceSlot` enum to the slot union. Automotive has no flat
 * spelling because its category cannot be guessed, so it is named explicitly.
 */
export function screenshotSlotFromDeviceSlot(slot) {
    return { kind: slot };
}
//# sourceMappingURL=play-slot.js.map